module.exports = __webpack_public_path__ + "img/hoimg3.a55cfdc3.png";